<template>
  <div v-loading="loading" class="upload">
    <div v-for="(item, index) in documentType" :key="item.id">
      <UploadList
        :title="`${index + 1}. ${item[`name${$t('message.lan')}`]}`"
        :documentType="item"
        :application="form"
        @change="handleChange($event, item.id)"
        @removeFile="removeFile(item.id)"
      ></UploadList>
    </div>

    <div class="next_btn">
      <GradientBtn white @click="back">{{ $t("message.back") }}</GradientBtn>
      <GradientBtn @click="next" :disabled="loading">{{
        $t("message.DataRegistration.upload.next")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import UploadList from "./UploadList";
import GradientBtn from "@/components/GradientBtn";
import DocumentTypeAPI from "@/api/hzmb-gh/DocumentTypeAPI";
import HzmbGFirstApplicationAPI from "@/api/hzmb-gh/HzmbGFirstApplicationAPI";
import VssViewAPI from "@/api/hzmb-gh/VssViewAPI";
export default {
  components: { UploadList, GradientBtn },
  data() {
    return {
      serviceType: this.$route.meta.serviceType,
      applicationId: this.$route.params.applicationId,
      loading: false,
      form: {},
      verifyForm: {},
      documentType: [],
    };
  },
  methods: {
    handleChange(file, id) {
      this.documentType = this.documentType.map((item) => {
        if (item.id == id) {
          item.file = file;
        }
        return item;
      });
    },
    // 移除文件
    removeFile(id) {
      this.documentType = this.documentType.map((item) => {
        if (item.id == id) {
          delete item.file;
        }
        return item;
      });
    },
    next() {
      // 驗證必填項
      const documentType = this.documentType;
      let isCheck = true;
      for (let i in documentType) {
        if (documentType[i].required && !documentType[i].file) {
          isCheck = false;
        }
      }
      // console.log(isCheck);
      if (!isCheck) {
        this.$message({
          type: "error",
          message: this.$t("message.upload_required"),
        });
        return false;
      } else {
        this.$router.push(`/hzmb-g-first/check/${this.applicationId}`);
      }
    },
    back() {
      this.$router.push(`/hzmb-g-first/application/${this.applicationId}`);
    },
    async getDocument() {
      try {
        this.loading = true;
        const res = await DocumentTypeAPI.get(this.serviceType);
        let document = res;
        const app = this.form || {};
        if (app.documents && app.documents.length > 0) {
          for (let i in app.documents) {
            let doc = app.documents[i];
            if (doc.documentType && doc.documentType.id) {
              // 儲存到對應文件類型中
              document = document.map((ele) => {
                if (ele.id === doc.documentType.id) {
                  ele.file = {
                    uid: "-1",
                    name: doc.file && doc.file.filename,
                    size: doc.file && doc.file.fileSize,
                    status: "ready",
                  };
                  ele.document = doc;
                }
                return ele;
              });
            }
          }
        }
        // console.log(document);
        this.documentType = document;
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    async get() {
      try {
        this.loading = true;
        let form = await HzmbGFirstApplicationAPI.getById(this.applicationId);
        this.identityTypes = await VssViewAPI.getHzmbGIdType();
        this.sexs = await VssViewAPI.getsexs();
        this.$set(this, "form", form);
      } catch (error) {
        if (error.code === "DUPLICATE_APPROVING_APPLICATION") {
          this.$alert(
            this.$t("message.ErrorMessage.DUPLICATE_APPROVING_APPLICATION")
          );
          this.$router.replace(`/hzmb-truck-hk`);
        } else {
          this.$error(error);
        }
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    this.verifyForm = JSON.parse(localStorage.getItem("verifyForm")) || {};
    await this.get();
    await this.getDocument();
  },
};
</script>

<style lang="scss" scoped>
.upload {
  max-width: 690px;
  min-height: 500px;
  margin: 24px auto;
  background: #fff;
  overflow: hidden;
  padding-left: 14px;
  padding-right: 14px;
}
</style>
